import { useEffect } from "react";
import { useDispatch, useSelector } from "react-redux";
import { fetchCollections } from "../redux/collectionsSlice";

export const useCollections = () => {
    const dispatch = useDispatch();

    const { items, loading, error } = useSelector(
        (state) => state.collections
    );

    useEffect(() => {
        document.title = "Obsession - Collections";
        dispatch(fetchCollections());
    }, [dispatch]);

    return {
        collections: items.collections,
        categories: items.categories,
        loading,
        error,
    };
};
